<template>
  <div class="container">
    <div id="page1-div" class="container interline border page-container">
      <div class="col-12 p-4 text-justify">
        <div class="col-12 text-center my-3 py-2 bg-gpi-azul">
          <span class="ft13Black text-white">
            ACUSE ENTREGA DE IMPUESTO VEHICULAR
          </span>
        </div>
        <div class="col-12 text-right pt-4 pb-3 ">
          <span class="ft12Black"
            >CD,
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }},
            </span>
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.estado_cliente }}
            </span>
            a
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}.
            </span>
          </span>
        </div>
        <div class="col-12 pb-2 px-0 text-justify">
          <span class="ft12" v-bind:class="{ marca: data.showMarca }">
                {{ data.lote }}
          </span>
          <span class="ft12">
            (en adelante, el ¨Proveedor¨)
          </span>
        </div>
        <div class="col-12 px-0 text-justify">
          <span class="ft12">
            <span class="ft12Black">
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.nombre_cliente }},
              </span>
            </span>
            (en adelante, el ¨Acreditado¨) en relación con el contrato de
            crédito con garantía prendaria de fecha
            <span v-bind:class="{ marca: data.showMarca }">
              <u class="ft12Black"> {{ data.fecha_contrato }},</u>
            </span>
            celebrado con GPI AUTO COMERCIAL SAPI DE C.V. en su carácter
            Acreditante y para los efectos establecidos en dicho documento, por
            medio del presente manifiesto mi entera conformidad en relación con
            el Bien Adquirido, el cual recibo por parte del Proveedor en óptimas
            condiciones físicas y mecánicas y de conformidad con las siguientes
            características:
            <br />
            <br />
            <span class="ft12">Descripción del Bien:</span>
            <br />
            <br />
          </span>
        </div>
        <div class="col-12 border border-dark row m-0 p-0">
          <div
            class="col-3 border-bottom bg-gpi-azulito border-dark auto border-right"
          >
            <span class="ft12Black">Marca</span>
          </div>
          <div class="col-3 border-bottom border-dark auto border-right">
            <span class="ft12"
              ><span v-bind:class="{ marca: data.showMarca }">
                {{ data.marca_vehiculo }}</span
              ></span
            >
          </div>
          <div
            class="col-3 border-bottom border-dark auto bg-gpi-azulito border-right"
          >
            <span class="ft11Black">Modelo/Tipo de Vehículo</span>
          </div>
          <div class="col-3 border-bottom border-dark auto ">
            <span class="ft12"
              ><span v-bind:class="{ marca: data.showMarca }">
                {{ data.modelo_vehiculo }}</span
              ></span
            >
          </div>

          <div
            class="col-3 border-bottom border-dark bg-gpi-azulito auto border-right"
          >
            <span class="ft12Black">Año</span>
          </div>
          <div class="col-3 border-bottom border-dark auto border-right">
            <span class="ft12"
              ><span v-bind:class="{ marca: data.showMarca }">
                {{ data.año_vehiculo }}</span
              ></span
            >
          </div>
          <div
            class="col-3 border-bottom border-dark bg-gpi-azulito auto border-right"
          >
            <span class="ft12Black">Numero de Motor</span>
          </div>
          <div class="col-3 border-bottom border-dark auto">
            <span class="ft12"
              ><span v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_motor_vehiculo }}</span
              ></span
            >
          </div>

          <div class="col-3 border-dark auto bg-gpi-azulito border-right">
            <span class="ft12Black">Número de Serie</span>
          </div>
          <div class="col-3 border-dark auto border-right">
            <span class="ft12"
              ><span v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_serie_vehiculo }}</span
              ></span
            >
          </div>
          <div class="col-3 border-dark border-right bg-gpi-azulito"></div>
          <div class="col-3 "></div>
        </div>
        <div class="col-12 pb-2 px-0">
          <span class="ft12">Documentos que se entregan al Acreditado:</span>
        </div>
        <div class="col-12 border border-dark row m-0 p-0 ">
          <div
            class="col-1 text-center border-bottom border-dark auto border-right bg-light"
          >
            <span class="ft12Black">N°</span>
          </div>
          <div
            class="col-5 text-center border-bottom border-dark auto border-right bg-light"
          >
            <span class="ft12Black">Documento</span>
          </div>
          <div
            class="col-1 border-bottom border-dark m-0 p-0 border-right text-center bg-light"
          >
            <span class="ft12Black">Original</span>
          </div>
          <div
            class="col-5 border-bottom border-dark text-center auto bg-light"
          >
            <span class="ft12Black">Observaciones</span>
          </div>
          <div
            class="col-1 text-center border-bottom border-dark py-1 m-0 border-right"
          >
            <span class="ft12Black">1</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0 border-right">
            <span class="ft12">Cambio de Propietario</span>
          </div>
          <div
            class="col-1 border-bottom border-dark py-1 m-0 border-right text-center"
          >
            <span class="ft12Black">x</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0">
            <span class="ft12"></span>
          </div>
          <div
            class="col-1 text-center border-bottom border-dark py-1 m-0 border-right"
          >
            <span class="ft12Black">2</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0 border-right">
            <span class="ft12"
              >REFRENDO O TENENCIA {{ data.año_contrato }}</span
            >
          </div>
          <div
            class="col-1 border-bottom border-dark py-1 m-0 border-right text-center"
          >
            <span class="ft12Black">x</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0">
            <span class="ft12"></span>
          </div>
          <div
            class="col-1 text-center border-right border-bottom border-dark py-1 m-0"
          >
            <span class="ft12Black">3</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0 border-right">
            <span class="ft12"
              >REFRENDO O TENENCIA {{ data.año_contrato - 1 }}</span
            >
          </div>
          <div
            class="col-1 border-bottom border-dark py-1 m-0 border-right text-center"
          >
            <span class="ft12Black">x</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0">
            <span class="ft12"></span>
          </div>
          <div
            class="col-1 text-center border-bottom border-dark py-1 m-0 border-right"
          >
            <span class="ft12Black">4</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0 border-right">
            <span class="ft12"
              >REFRENDO O TENENCIA {{ data.año_contrato - 2 }}</span
            >
          </div>
          <div
            class="col-1 border-bottom border-dark py-1 m-0 border-right text-center"
          >
            <span class="ft12Black">x</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0">
            <span class="ft12"></span>
          </div>
          <div
            class="col-1 text-center border-bottom border-dark py-1 m-0 border-right"
          >
            <span class="ft12Black">5</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0 border-right">
            <span class="ft12"
              >REFRENDO O TENENCIA {{ data.año_contrato - 3 }}</span
            >
          </div>
          <div
            class="col-1 border-bottom border-dark py-1 m-0 border-right text-center"
          >
            <span class="ft12Black">x</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0">
            <span class="ft12"></span>
          </div>
          <div
            class="col-1 text-center border-bottom border-right border-dark py-1 m-0"
          >
            <span class="ft12Black">6</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0 border-right">
            <span class="ft12"
              >REFRENDO O TENENCIA {{ data.año_contrato - 4 }}</span
            >
          </div>
          <div
            class="col-1 border-bottom border-dark py-1 m-0 border-right text-center"
          >
            <span class="ft12Black">x</span>
          </div>
          <div class="col-5 border-bottom border-dark py-1 m-0">
            <span class="ft12"></span>
          </div>

          <div class="col-1 border-dark py-1 m-0 border-right text-center">
            <span class="ft12Black">7</span>
          </div>
          <div class="col-5 border-dark py-1 m-0 border-right">
            <span class="ft12">Otro</span>
          </div>
          <div class="col-1 border-dark py-1 m-0 border-right text-center">
            <span class="ft12Black"></span>
          </div>
          <div class="col-5 border-dark py-1 m-0">
            <span class="ft12"></span>
          </div>
        </div>
        <div class="col-12 px-0 pb-3 text-justify">
          <span class="ft12">
            Así mismo manifiesto y acepto que en caso de cualquier consulta y/o
            reclamación relacionada con el bien, deberá acudir directamente con
            el Proveedor, en caso de siniestro o pérdida total sobre el
            ¨BIEN(ES)¨ el ¨ACREDITADO¨ se obliga a entregar la documentación
            requerida por el ¨ACREDITANTE¨ .
            <br /><br />
            En garantía del pago del ¨CREDITO¨ de todas y cada una de las
            obligaciones que derivan del presente Instrumento y de las demás
            prestaciones que resulten a cargo del ¨ACREDITADO¨ ,
            esta(s)constituye(n) prenda a favor del ¨ACREDITANTE¨ sobre el (los)
            BIEN(ES),debiendo anotar en la factura y demás documentos que
            acreditan la propiedad del(los) mismo(s),que dicho(s) bien(es) se
            encuentra(n) dado(s) en garantía prendaria a favor de ¨ACREDITANTE¨,
            debiendo entregar dicha(s) factura(s) y demás documentos al
            ¨ACREDITANTE¨ en el acto mismo que ¨ACREDITADO¨ adquiere el(los)
            BIEN(ES).
            <br /><br />
            El(Los) BIEN(ES) dado(s) en prenda quedara(n) en poder de
            ¨ACREDITADO¨ , a quien se considerara para los fines de su
            responsabilidad civil y penal como depositario judicial del(los)
            mismo(s),aceptando el desempeño de dicho cargo a título gratuito y
            obligándose a mantener dicho(s) BIEN(ES) a disposición del
            ¨ACREDITANTE¨.
            <br /><br />
            Con independencia a lo anterior, acuerdo dar cumplimiento a las
            obligaciones derivadas del contrato referido.
          </span>
        </div>
        <div class="col-12 row pt-4">
          <div class="col-3 "></div>
          <div class="col-6 border border-dark text-center pb-3 pt-5">
            <u class="ft12">ACREDITADO</u>
          </div>
          <div class="col-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/Caratura1/InpuestoVehicular.vue